const translate = {
    common: {
        audit: "Audit",
        login: "Login",
        password: "Password",
        maskedPassword: "**********",
        date: "Date",
        today: "Today",
        yesterday: "Yesterday",
        currentWeek: "Current week",
        currentMonth: "Current month",
        currentYear: "Current year",
        period: "Period",
        tier: "Tier",
        save: "Save",
        operators: "Operators",
        search: "Search",
        online: "Online",
        pause: "Pause",
        offline: "Offline",
        chats: "Chats",
        chat: "Chat",
        channels: "Channels",
        type: "Type",
        token: "Token",
        enabled: "Enabled",
        name: "Name",
        settings: "Settings",
        permissions: "Permissions",
        contact: "Contact",
        channel: "Channel",
        accounts: "Accounts",
        contactCommunications: "Contact communications",
        cancel: "Cancel",
        delete: "Delete",
        restore: "Restore",
        detach: "Detach",
        contacts: "Contacts",
        messengers: "Messengers",
        created: "Created",
        status: "Status",
        mailing: "Mailing",
        start: "Start",
        message: "Message",
        analytics: "Analytics",
        synonyms: "Synonyms",
        export: "Export",
        import: "Import",
        publish: "Publish",
        changeVersion: "Change version",
        undo: "Undo",
        answer: "Answer",
        active: "Active",
        inactive: "Inactive",
        pending: "Pending",
        apply: "Apply",
        setting: "Setting",
        edited: "edited",
        editAsJson: "Edit as JSON",
        editAsTable: "Edit as table",
        image: "Image",
        file: "File",
        send: "Send",
        close: "Close",
        reject: "Reject",
        confirm: "Confirm",
        setOn: "Set on",
        logout: "Logout",
        wrongPasswordOrLoginOrLicenseMessage: "Authorisation Error. Check your login and password.",
        id: "Id",
        operator: "Operator",
        channelType: "Channel Type",
        channelName: "Channel Name",
        chatTag: "Tag",
        phrase: "Phrase",
        data: "Data",
        fileSendLikeImageError: "This image type can only be sent as a file",
        changesNotBeApplied: "The changes you make will not be applied to the changed settings",
        supervisor: "Supervisor",
        admin: "Admin",
        bot: "Bot",
        offlineStatusConfirmation: "Switching to offline will remove all chats and move them to the queue. Continue?",
        chatType: "Chat Type",
        operatorType: "Operator Type",
        messengerExternalId: "Messenger external id",
        ascending: "Ascending",
        descending: "Descending",
        ai: "AI",
        attachment: "Attachment",
        stop: "Stop",
        location: "Location",
        audio: "Audio",
        video: "Video",
    },
    analytics: {
        statistics: "Statistics",
        monitoring: "Monitoring",
        reports: "Reports",
        exportReport: "Export",
        comeFrom: "Come from",
        dialog: "Dialog",
        wentTo: "Went to",
        getSettingForChartsMessage: "Cannot load setting for charts.",
        reportOutOfRangeException: "The report cannot be generated due to file format limitations.",
        reportException: "An error occurred while uploading the report.",
    },
    channels: {
        operatorsForChannel: "Operators for channel",
        operator: "Operator",
        feedback: "Feedback",
        vip: "VIP",
        spam: "Spam",
        comments: "Comments",
        emptyNameTooltipErrorMessage: "Name cannot be empty",
        emptyTokenTooltipErrorMessage: "Token cannot be empty",
        channelCreatingErrorMessage: "Please, save or delete new channel",
        createChannel: "Create Channel",
        sureDeleteChannel: "Are you sure you want to delete the channel?",
        saveChannelSuccessMessage: "Successfully saved the channel",
        saveNewChannelSuccessMessage: "Successfully created the channel",
        saveChannelErrorMessage: "An error occured while saving the channel",
        saveNewChannelErrorMessage: "Cannot save new channel",
        deleteChannelSuccessMessage: "Successfully deleted the channel",
        channelAlreadyExists: "A channel with this token already exists",
        uniformWidgetStartSignalRError: "An error occurred while connecting to the connector {{url}}",
        deleteNewChannelSuccessMessage: "Channel was not saved",
        deleteChannelErrorMessage: "An error occured while deleting the channel",
        deleteNewChannelErrorMessage: "Channel with ID {0} cannot be deleted due to it having opened chats: ",
        copyScriptHeader: "Script copied",
        copyScriptBody: "Script has been copied to the clipboard. Use Ctrl+V to paste it to your site.",
        telegram: "Telegram",
        viber: "Viber",
        viberAlfa: "Viber аlfa",
        vk: "Vk",
        widget: "Widget",
        facebook: "Facebook",
        weChat: "WeChat",
        instagram: "Instagram",
        uniformWidget: "Uniform Widget",
        ednaWhatsApp: "WhatsApp (Edna)",
        whatsApp: "WhatsApp",
        voiceChannel: "Voice Channel",
        telegramPrivate: "Telegram (Private)",
        restartChannelSuccessMesage: "Channel restarted successfully",
        restartChannelQuestion: "Are you sure you want to restart the channel?",
        restartOnlyEnabledChannel: "Channel must be enabled",
        askYouWannaDeleteChannel: "{0} user(s) use this channel for communication. Will the ability to communicate with them be lost. Do you still delete?",
        channelNotExists: "Channel with Id {{channelId}} not exists",
        sendPulse:"SendPulse",
        sms: "Sms",
    },
    chat: {
        transfer: "Transfer",
        comment: "Comment",
        transferToOperator: "Transfer to operator",
        transferToBot: "Transfer to bot",
        transferToGroup: "Transfer to group",
        invite: "Invite",
        editMessage: "Edit message",
        doLeaveChat: "Do you want to leave the chat?",
        doExportChat: "Do you want to export chat?",
        exportSuccess: "Chat exported successfully",
        exportError: "Export to external CRM is not configured",
        externalCrmOptionsAreNotConfidured: "Options of external crm are not configured",
        export: "Export",
        pause: "Pause",
        unpause: "Unpause",
        setPauseHeader: "Choose pause category",
        removePauseHeader: "Remove pause",
        removePause: "Remove pause",
        resendMessage: "Resend the message",
        setPause: "Pause",
        pauseWithoutNotifacation: "Pause without client notification",
        pauseWithNotifacation: "Pause with client notification",
        pauseBotChatError: "Cannot pause the chat with bot",
        leave: "Leave",
        sendingFiles: "Sending {{sendingFilesCount}} file(s)...",
        join: "Join",
        close: "Close",
        closeChat: "Close chat",
        save: "Save",
        fillInfo: "Fill in the information",
        category: 'category',
        subject: 'subject',
        categoryAndSubjectSavedError: 'To close the chat, fill in all the fields',
        categoryAndSubjectSavedSuccessfully: 'Category and subject were saved successfully',
        messageDeleted: "Message deleted",
        messageFileNoEdit: "Message with file/image cannot be edited.",
        messageFileNoDelete: "Message with file/image cannot be deleted.",
        cannotSaveEmptyMessaage: "Cannot save empty message, use delete button",
        cannotEditMessageWrongChannelType: "Cannot edit message. Wrong channel type.",
        sendFileMessageError: "An error occurred while sending the file",
        continue: "Continue",
        tagSaveSuccess: "The tags saved successfully",
        markAsSpam: "Mark as spam",
        contactHasOpenedChatException: "There is an open chat with this contact. ChatId - {0} Operator - {1}",
        enabledChannelNotFoundException: "Cannot start a new chat due to there is no enabled channel",
        tagSaveError: "To save tags fill both fields",    
        searchByMessenger: "Include history from the messenger",
        cannotCloseChatNoAccesRights: "Can't close the chat because you don't have access rights",
        createNewChatError: "There is no started channel to create a chat by messenger",
        initConversationError: "An error occurred while sending a template message",
        businessInitiatedTemplateNotFound: "Cannot start a new chat due to the channel does not have a template starting message", 
        chatTypePrivate: 'Private messages',
        chatTypeGroup: 'Group',
        chatTypeComment: 'Comments',
        chatTypeMailing: 'Mailing',
        summary: 'Summary',
        summaryCompleted: 'Completed',
        summaryFailed: 'Failed',
        summaryInProgress: 'In Progress',
        nluSearchTooltip: 'Search in NLU...',
        deleted: 'deleted',
        cannotEditDeleteMessage: "Cannot edit message. This message has been deleted.",
        chatClosedWaitingClientResponse: "Chat with client created with template and closed in wait for client response.", 
        selectTemplate: "Select a template to send",
        show: "Show",
        hide: "Hide",
    },
    chats: {
        my: "My",
        withMe: "With Me",
        all: "All",
        archive: "Archive",
        autoUpdateChat: "Auto-update",
        info: "Info",
        statistics: "Statistics",
        closed: "Closed",
        pause: "PAUSE",
        active: "Active",
        expired: "Expired",
        finished: "Finished",
        missed: "Missed",
        chatNumber: "Chat Number",
        askYouWannaCloseChat: "Do you want to close the chat?",
        askYouWannaJoinChat: "Do you want to join the chat?",
        askYouWannaReopenChat: "Do you want to reopen the chat?",
        operatorNotAssignedYetMessage: "Not assigned yet",
        openChatErrorMessage: "Something went wrong during chat opening.",
        continueChatErrorMessage: "Cannot start the chat. Please make sure the channel exists and is started.",
        editMessageSuccessMessage: "Message was successfully edited",
        deleteMessageSuccessMessage: "Message was successfully deleted",
        deleteMessageError: "An error occurred while deleting",
        editMessageErrorMessage: "An error occurred while editing.",
        chatAlreadyClosing: "Chat closing is already in processing",
        chatClosedSuccessfully: "Chat closed successfully",
        chatClosedErrorMessage: "An error occurred while closing the chat",
        enterChatName: "enter chat name...",
        messageFromMyself: "You",
        messageFromClient: "Client",
        messageFromOperator: "Operator",
        messageFromSystem: "System",
        messageFromBot: "Bot",
        attachmentMessage: "*attachment*",
    },
    contact: {
        sureDeleteAccount: "Are you sure you want to delete your account?",
        createNewAccounts: "Create new accounts",
        noRecords: "No records",
        phoneNumber: "Phone Number",
        firstName: "First Name",
        lastName: "Last Name",
        middleName: "Middle Name",
        name: "Name",
        chatName: "Chat Name",
        comment: "Comment",
        chatsCount: "Chats count",
        externalId: "External Id",
        locale: "Locale",
        noContacts: "No contacts",
        createContact: "Create contact",
        saveContactSuccessMessage: "Successfully saved the contact",
        saveNewContactSuccessMessage: "Successfully created the contact",
        saveContactErrorMessage: "An error occured while saving the contact",
        saveNewContactErrorMessage: "Cannot save new contact",
        deleteContactSuccessMessage: "Successfully deleted the contact",
        deleteNewContactSuccessMessage: "Successfully deleted the new contact",
        deleteContactErrorMessage: "An error occured while deleting the contact",
        deleteMessenger: "Are you sure you want to delete the messenger?",
        cantDeletePrimaryContactMessenger: "You can not remove the primary messenger of the contact",
        createMessenger: "Create a new communication",
        channelName: "Channel name",
        chooseFile: "Choose a file",
        messengerNickname: "Nickname",
        messengerToken: "Number",
        contactFoundMessage: "Contact found",
        contactNotFoundMessage: "Contact not found",
        contactReceivingByIdNotFoundMessage: "Contact with id equal to {{contactId}} not found",
        errorSavingAccountWithoutData: "Cannot save an account with empty fields",
        errorSavingAccountOnlyWithSpaces: "Can't save account where fields consist of spaces",
        errorSavingAccountCharactersEqualOrMore50: "Cannot save an account where the number of characters in a field is greater than 50 characters",
        errorSavingAccountIdWithSpaces: "Can't save an account where the id field contains spaces",
        newDialogueWithClient: "Do you want to start a new dialogue with a client?",
        fillAtLeastOneAnthroponym: "Fill at least one anthroponym: first name, last name or middle name",
        unsupportedAvatarImageType: "Unsupported image type"
    },
    license: {
        botUsage: "Bots",
        operatorUsage: "Operators",
        nlpUsage: "NLU requests",
        mailingUsage: "Mailing",
        currentUsage: "Currently used",
        avalableUsage: "Total available",
        leftUsage: "Left",
        licenseExpiresAt: "License expires at {{date}}",
        licenseDaysLeft: "{{days}} days left",
        confirmPasswordNotMatchMessage: "Passwords do not match!",
        unknownErrorMessage: "An error occurred while activating access, contact your administrator!",
        licenseErrorMessage: "License error, contact your administrator!",
        licenseExpiredErrorMessage: "The license has expired, contact the administrator!",
        licenseAlreadyActivatedMessage: "This license has already been activated.",
        userAlreadyExistMessage: "A user with this login already exists.",
        loginFormatErrorMessage: "Login can contain only letters of the Latin alphabet, \"_\" sign and numbers ",
        updateLicenseSuccessMessage: "License updated successfully!",
        updateLicenseErrorMessage: "License update error!",
        licenseExpiresPart: 'You have {{days}} days of license left, contact your administrator!',
        mailingExpires: 'You have used {{mailingUsed}} mailings. Your licence has {{totalMailings}} mailings',
        nlpExpires: 'You have used {{nlpUsed}} NLUs. Your licence has {{totalNlps}} NLUs',
        license: "License",
        licenseDetails: "License Details",
        title: "Access activation",
        loginLabel: "Login",
        loginPlaceholder: "Login",
        passwordLabel: "Password",
        passwordPlaceholder: "Password",
        confirmPasswordLabel: "Confirm password",
        licenseTitle: "License details",
        submitButton: "Activate access",
        notEnoughSlotsError: "Not enough free slots. Contact your administrator for licensing issues",
        enabledOperatorsMoreThanSpecifiedInLic: "The number of activated operators exceeds the number of operators in the license. You can enable and disable operators in the Operators section",
        enabledBotsMoreThanSpecifiedInLic: "The number of activated bots exceeds the number of bots in the license. You can enable and disable bots in the Operators section",
        customerIdChanged: "License customer id can not be changed.",
    },
    mailing: {
        bot: "Bot",
        mailingResult: "Mailing result",
        additionalData: "Additional data",
        message: "Message",
        linkText: "Link text",
        linkUrl: "Link url",
        image: "Image",
        isEmergency: "Allow sending to active chat",
        disableLinkTracking: "Do not track clicks on links",
        sendingType: "Sending type",
        sendToAllMessengers: "Send to all messengers",
        sendToLastMessenger: "Send to last messengers",
        sendCascade: "Cascade mailing",
        uploadImage: "Upload",
        createMailing: "Create mailing",
        pending: "Pending..",
        inProgress: "In Progress",
        finished: "Finished",
        canceled: "Canceled",
        stopped: "Stopped",
        canNotSaveEmptyMessageError: "Message can not be empty.",
        canNotSendCascadeMailingWithoutSelectedChannels: "Can not send cascade mailing without selected channel types.",
        canNotSaveEmptyNameError: "Name can not be empty.",
        canNotSaveWrongLinkUrlError: "Cannot save. Link url is incorrect",
        canSaveLinkWithoutLinkTextError: "Cannot save. Link text is empty",
        canNotSaveWithoutBotError: "Cannot save. Bot not selected",
        saveMailingSuccess: "Mailing saved success.",
        saveMailingError: "An error occurred while saving.",
        startMailingStartMessage: "Mailing started.",
        deleteMailingSuccessMessage: "Mailing successfully deleted.",
        deleteMailingErrorMessage: "An error occurred while deleting the mailing.",
        sendMessageFailed: "An error occurred while sending the message. See app logs for more information",
        noFilterChoosenMessage: "The contact/chat filter is not selected, mailing will occur to all contacts",
        contactsWithTemplates: "Contacts with templates",
        templateVariables: "Template variables",
        mailingReceivingByIdNotFoundMessage: "Mailing with id equal to {{mailingId}} not found",
        fileMayNotBeDelivered: "Due to the size, the file may not be delivered to all messengers.",
        mailingResultsReceivingByIdNotFoundMessage: "Mailing result with id equal to {{mailingId}} was not found",
        stopMailingMessage: "The mailing has been stopped.",
    },
    nlp: {
        foundViaML: "This answer was found via ML.",
        question: "Question",
        answer: 'Answer',
        createNewTopic: "Create New Topic",
        createNewPair: "Create New Pair",
        doWantDeleteTopic: "Do you want to delete the topic?",
        doWantDeleteTopicPair: "Do you want to delete the topic pair?",
        doWantUndoTopicPairChanges: "Do you want to undo topic pair changes?",
        selectPair: "Select pair",
        applySelected: "Apply selected",
        deleteSelected: "Delete selected",
        transferQuestion: "Transfer question",
        move: "Move",
        to: "to",
        askYourQuestion: "Ask your question",
        unsupportedMessageType: "Unsupported message type",
        answerNotFound: "Answer not found",
        actualSearchString: "Actual search string:",
        sureRemoveButton: "Are you sure you want to remove the button ",
        buttonType: "Button type",
        text: "Text",
        value: "Value",
        noFoundTopicPair: "No topic pair found.",
        buttonTextExists: "A button with this text already exists.",
        newButton: "New button",
        buttonEditing: "Button editing",
        saveTopicSuccessMessage: "Successfully saved the topic",
        saveTopicErrorMessage: "An error occured while saving the topic",
        deleteTopicSuccessMessage: "Successfully deleted the topic",
        deleteTopicErrorMessage: "An error occured while deleting the topic",
        exportPairsErrorMessage: "An error occured while exporting pairs.",
        importPairsErrorMessage: "An error occured while importing pairs.",
        importPairsSuccessMessage: "Successfully imported pairs",
        publishQuestionsSuccessMessage: "Successfully published questions",
        publishQuestionsMLSuccessMessage: "Successfully published questions (ML)",
        publishQuestionsErrorMessage: "An error occured while publishing questions",
        publishQuestionsMLErrorMessage: "An error occured while publishing questions (ML)",
        saveTopicPairSuccessMessage: "Successfully saved the topic pair.",
        saveTopicPairErrorMessage: "An error occured while saving the topic pair.",
        synonyms: "Synonyms",
        synonyms_placeholder: "hi : howdy|hello|welcome\nwork : job|effort\nclear : plain|uncomplicated|understandable",
        synonyms_fill: 'Fill in the synonyms. Each word on a new line, followed by a colon and its synonyms separated by "|"',
        synonyms_needColon: "Missing colon between word and synonyms in string \n",
        synonyms_fewColons: "There are more than one separating colons in string ",
        synonyms_wrongCharacter: "Invalid character in string \n",
        synonyms_needWord: "Missing word in string \n",
        synonyms_needSynonyms: "Missing synonyms in string \n",
        synonyms_emptySynonym: "Empty synonym in string \n",
        synonym_stopWord: "Error. \"{{sw}}\" is a stop word",
        deleteTopicPairSuccessMessage: "Successfully deleted the topic pair(s)",
        deleteTopicPairErrorMessage: "An error occured while deleting the topic pair(s)",
        changeTopicPairStatusSuccessMessage: "Successfully changed the topic pair(s) status.",
        changeTopicPairStatusErrorMessage: "An error occured while changing the topic pair(s) status.",
        transferQuestionToTopicPairSuccessMessage: "Transferred successfully",
        transferQuestionToTopicPairErrorMessage: "An error occured while transferring the question to a topic pair.",
        theme: "Theme",
        triggerName: "Trigger name",
        trigger: "Trigger",
        subject: "Subject",
        source: "Source",
        topicPairContentType_text: "Text",
        topicPairContentType_markup: "Markup",
        topicPairContentType_video: "Video",
        topicPairContentType_audio: "Audio",
        topicPairContentType_navigation: "Navigation",
        topicPairContentType_textToSpeech: "Text-to-speech",
        topicPairContentType_iframe: "Iframe",
        nlpButtonType_trigger: "Trigger",
        nlpButtonType_text: "Text",
        nlpButtonType_link: "Link",
        nlpButtonType_customEvent: "Custom Event",
        nlpButtonType_back: "Back",
        nlpButtonType_requestContact: "Request Contact",
        nlpButtonType_requestGeolocation: "Request Geolocation",
        nlpButtonEdit: "edit",
        nlpButtonDelete: "delete",
        errorSendNLPSearchWhenOperatorOffline: "Go online or pause to continue chat",
        messageDontHaveAccessToTopic: "Sorry, you don't have access to this topic",
        questionWithOnlyStopWordsError: "Question <{{question}}> contains only stop words",
        changeVersionConfirm: "Unpublished changes will be lost, continue?",
        designerViewButton: "Designer",
        listViewButton: "List",
        designerAlignNodesButton: "Align",
        designerTakeScreenshotButton: "Export to file",
        aiSearchWithNullConfidenceError: "An error occurred while searching using vector. Forgot to publish the topic?",
        noOptionsText: "No matching options found",
        exceededLimitButton: "The 20 character limit has been exceeded, in some messengers the button may not be delivered.",
        autocompleteOpenText: "Open",
        autocompleteCloseText: "Close",
        autocompleteClearText: "Clear",
        emptyNlpTooltipMessage: "NLU name cannot be empty",
        topicReceivingByIdNotFoundMessage: "Topic with id equal to {{topicId}} not found"
    },
    operators: {
        name: "Name",
        displayName: "Display name",
        createOperator: "Create operator",
        sureRemoveOperator: "Are you sure you want to remove the operator?",
        emptyNameTooltipMessage: "Name cannot be empty",
        emptyLoginTooltipMessage: "Login cannot be empty",
        emptyPasswordTooltipMessage: "Password cannot be empty",
        minLengthPasswordMessage: "Password should be longer then ",
        maxLengthPasswordMessage: "Password should be shorter then ",
        minLengthLoginMessage: "Login should be longer then ",
        maxLengthLoginMessage: "Login should be shorter then ",
        changeAvatarNullIdErrorMessage: "Cannot change avatar of non created operator",
        saveOperatorSettingsNullIdMessage: "Cannot save settings of non created operator",
        spaceInLoginErrorMessage: "Login cannot contain spaces",
        operatorCreatingErrorMessage: "Cannot create several operators at a time!",
        uploadScript: "Upload",
        saveOperatorNoChangesMessage: "Operator has not been changed",
        saveOperatorSuccessMessage: "Successfully saved the operator",
        duplicatedOperatorNameErrorMessage: "Operator with the same name already exists",
        duplicatedOperatorLoginErrorMessage: "Operator with the same login already exists",
        incorrectFileFormatErrorMessage: "Invalid file format. Please upload a .zip archive",
        deleteOperatorSuccessMessage: "Successfully deleted the operator",
        cannotDeleteYourself: "You cannot delete the operator you logged in",
        deleteOperatorErrorMessage: "An error occured while deleting the operator",
        incorrectLoginMessage: "Login contains invalid characters",
        fileNotChoosen: "File not choosen",
        removeOperator: "Remove Operator",
        logoutOperatorByOperator: "Administrator {0} has logged you out",
        logoutOperator: "Administrator has logged you out",
        setAvatarError: "An error occurred while setting the file",
        setAvatarSuccess: "Avatar successfully updated",
        downloadBotScriptError: "An error occurred while downloading the bot script",
        operatorTypeOperator: "Operator",
        operatorTypeBot: "Bot",
        operatorTypeSupervisor: "Supervisor",
        operatorTypeHuman: "Human",
        operatorTypeQueue: "Queue"
    },
    settings: {
        createSettings: "Create settings",
        settingIdCannotBeEmpty: "Cannot save a setting with an empty id.",
        confirmDeleteSetting: "Delete setting",
        settingIdAlreadyExists: "Setting with Id {id} already exists.",
        settingId: "Setting Id",
        emptySettingTooltipMessage: "Setting Id cannot be empty",
        key: "Key",
        value: "Value",
        system: "System",
        integration: "Integration",
        settingSaved: "Setting successfully saved",
        settingDeleted: "Setting deleted"
    },
    chatsPanel: {
        youAreLoggedInAs: "You are logged in as ",
        toChangeTheUserPress: "To change the user press ",
        haveBeenAssignedChannels: "You have been assigned to the channels: ",
        errorReopenChatDueOfflineStatus: "Go online or pause to continue chat",
        cannotOpenChatInWidgetChannel: "Cannot open the chat in a widget channel.",
        sendMessageError: "An error occurred while sending messages",
        sendFileMessageError: "An error occurred while sending the file",
    },
    permission: {
        editPermissionsFor: "Edit permissions for ",
        tabRole: "Roles",
        tabUsers: "Users",
        selectUser: "Select user",
        Audit_Manage: "Audit management",
        Contacts_Manage: "Contact management",
        Chats_ManageOwnChats: "Management of own chats",
        Chats_TransferChats: "Transfer chats",
        Mailing_Manage: "Mailings management",
        Chats_ManageOthersChats: "Management of other people's chats",
        NLP_Search: "Search in NLU database",
        NLP_Manage: "NLU database management",
        Operators_Manage: "Management of the operator list and channel assignment to operators",
        Channels_Manage: "Channels management",
        Integrations_Manage: "Integration settings management",
        CanManageAnalytics: "Working with analytics",
        License_Manage: "License management",
        savePermissionsSuccessMessage: "Successfully saved permissions",
        Chats_SendFiles: "Sending files",
        Permission_Manage: "Permission management",
    },
    error: {
        nlpTopicAlreadyExistsError: "Topic with name {{topicName}} already exists.",
        disableWithOpenChats: "Update channel with ID {{channelId, number}} failed: Cannot disable channel if it has opened chats: {{openedChats, number}}",
        changeTokenWhenOpenChats: "Update channel with ID {{channelId}} failed: Cannot change type or token if the channel has chats",
        connectionError: "Connection error. Try again later.",
        invalidDateMessage: "Invalid date format",
        leftDateLessMessage: "The left date is less than the right date",
        error: "Error!",
        invalidTokenErrorMessage: "Please login to continue",
        loginFailed: "Authorization error. Check your login and password",
        nlpTopicNotFoundError: "Topic {{topicName}} was not found",
        channelNotInitialized: "Channel is not initialized",
        botBlockedByUser: "User has blocked the channel!",
        moreThanOneFile: "You can drag only 1 file",
        incorrectFileType: "You can drag only files",
        FailedLicenseValidation: "License error, contact your administrator!",
        LicenseExpired: "The license has expired, contact your administrator!",
        LicenseAlreadyActivated: "This license is already activated.",
        UserAlreadyExist: "A user with this login already exists.",
        sendFileNotSupported: "This channel does not support sending files",
        typeOfSendedFileNotSupported: "This channel does not support sending this file type",
        saveImageBase64: "Can not save image from Base64 picture",
        cannotSendMessageNotChatParticipant: "Cannot send message due to operator is not a chat participant",
        sendMessageFailed: "Send message failed. ChatId: {{chatId, number}} OperatorId: {{operatorId, number}}",
        duplicatedData: "Data duplication for {{constraintName}}",
        messengerNotFound: "Can't find available messengers",
        chatNotFound: "Chat {{chatId}} couldn't be found",
        fileMaxSize: "The maximum file size should not exceed {{maxSize}}MB",
        fileSizeExceeded: "Could not send the file. Its size ({{currentSizeMb}} MB) exceeds the maximum allowed limit of {{maxSizeMb}} MB",
        fileDownloadError: "File download error",
        grafanaCreateScope: "Failed to create scope for grafana",
        grafanaLogin: "Failed to get cookie for charts",
        scriptFileNotFound: "Bot script file not found",
        invalidOperatorModel: "Operator data is invalid for save",
        fileTooLargeErrorMessage: "File size is too large",
        chatAlreadyClose: "Chat {{chatId, number}} is already closed.",
        messageSentOutsideOfAllowedWindow: "Message can not be send into that chat outside of 24 hours after client's last message.",
        messageSentOutsideOf48HourAllowedWindow: "Message can not be send into that chat outside of 48 hours after client's last message.",
        messageLengthExceeded: "Character limit exceeded. Maximum message length: {{symbolsCount}} characters.",
        parentCommentDeleted: "Parent comment was deleted by author. Reply can not be sent.",
        instagramUserDisabledMentions: "Mentioned user disabled mentions in their settings. Please, remove mention and try again.",
        messageModificationOutsideOfAllowedWindow: "The message cannot be modified, too much time has passed since it was sent.",
        fetchFailedQr: "Couldn't get QR code",
        saveTelegramPrivateMessengerError: "Failed to save Telegram Private messenger",
        channelClientNotInitializedException: "Channel is not initialized, start the channel first. Channel id: {{channelId}}",
        chatNotCreated: "Chat was not created. Channel id: {{channelId}}, user id: {{userId}}",
        dailyLimitExceeded: "Telegram private daily limit exceeded. Limit: {{limit}}.",
        commentUnavailable: "Cannot send message because the comment is unavailable. ChatId: {{chatId}}, MessageId: {{messageId}}",
        microphoneOrCameraPermissonNotGranted: "You need to grant access to microphone/camera for the feature to work",
        recordingVideoTooLarge: "Recording video is too large",
    },
    notification: {
        locationText: "Location",
        documentText: "Document",
        photoText: "Photo",
        newMessageInChat: "New message in chat ",
        newChatRecieved: "New chat received!",
        chatId: "ChatId-",
        connectionError: "Connection error!",
        connectionErrorText: "Failed to restore connection, you will be transferred to Offline status",
        connectionAbortText: "The connection was broken. Refresh the page."
    },
    audit: {
        operatorConnectedBySignalR: "Operator connected by SignalR",
        operatorDisconnectedBySignalR: "Operator disconnected by SignalR",
        operatorWentOnline: "Operator went online",
        operatorWentPause: "Operator went pause",
        operatorWentOffline: "Operator went offline",
        createSetting: "Operator created setting",
        updateSetting: "Operator updated setting",
        removeSetting: "Operator removed setting",
        createChannel: "Operator created channel",
        updateChannel: "Operator updated channel",
        removeChannel: "Operator removed channel",
        createOperator: "Operator created operator",
        updateOperator: "Operator updated operator",
        removeOperator: "Operator removed operator",
        operatorWentPause1: "Operator went pause1",
        operatorWentPause2: "Operator went pause2",
        operatorWentPause3: "Operator went pause3",
        operatorWentPause4: "Operator went pause4",
        operatorWentPause5: "Operator went pause5",
        operatorWentPause6: "Operator went pause6",
        operatorWentPause7: "Operator went pause7",
        operatorWentPause8: "Operator went pause8",
        operatorWentPause9: "Operator went pause9",
        operatorWentPause10: "Operator went pause10",
    },
    qr: {
        telegram: {
            scanCode: "Scan the QR code. If the QR code has expired, wait or click refresh.",
            authorized: "You are logged in!",
            initializing: "Initializing...",
            emptySettings: "The necessary settings are missing: ApiId and ApiHash",
            startChannel: "Channel not running.",
            requiresPassword: "Cloud password required. Refresh the page and check the settings.",
            requiresManualInput: "Manual input required. Refresh the page and check the settings.",
            loading: "Loading...",
            refresh: "Refresh",
            enterByQr: "Enter by Qr-code",
        }
    }
};

export default translate;
